module.exports = __webpack_public_path__ + "img/061.ac3200ba.png";